jQuery(window).load(function(){

  
  $('.flexslider').flexslider({
	animation: "slide",
	slideshow: true,
	animationDuration: 700,
	slideshowSpeed: 6000,
	animation: "fade",
	controlsContainer: ".flex-controls",
	controlNav: false,
	keyboardNav: true
  }).hover(function(){ $('.flex-direction-nav').fadeIn();}, function(){$('.flex-direction-nav').fadeOut();});
  

  $("select.loc_on_change").change(function(){
	if($(this).attr("value") == "#") return false;
	window.location = $(this).attr("value");
  });

  
  var IE6 = false /*@cc_on || @_jscript_version < 5.7 @*/;
  if(IE6){
	if($("#placeholder img").width() > 360){
	  $("#placeholder img").css('width', '360px');
	} else {
	  $("#placeholder img").css('width', $("#placeholder img").width()+'px'); // restrict to initial width of image
	}
  } else {
	$("#placeholder img").css('maxWidth', $("#placeholder img").width()+'px'); // restrict to initial width of image
  }

  var pw = $("#placeholder img").width() + 8;
  $("#placeholder img").parents('div.featured').css('maxWidth', pw+'px'); // force IE to play nice
  
});

jQuery(document).ready(function($){

  $(".tweet").tweet({ // twitter plugin
	username: "shopify",
	join_text: "auto",
	avatar_size: 32,
	count: 2,
	auto_join_text_default: "",
	auto_join_text_ed: "",
	auto_join_text_ing: "",
	auto_join_text_reply: "",
	auto_join_text_url: "",
	loading_text: "Loading Tweets..."
  });

  $("a.zoom").fancybox({
	padding:0,
	'titleShow': false,
	overlayColor: '#000000',
	overlayOpacity: 0.2
  });

  $('#create_customer').find('.btn').bind('click', function(e) {
	if(e.preventDefault) {
	  e.preventDefault();
	}

	var $this = $(this).parent().parent();

	if($this.find('.errors').length) {
		$this.find('.errors').remove();
	}

	var $password = $('#password-field');
	var $passCheck = $('#password-check');

	console.log($password.val() + ' | ' + $passCheck.val())

	if($password.val() && $passCheck.val() && $password.val() === $passCheck.val()) {
		$this.submit();
	} else {
		if($this.find('.errors').length) {
			if($('.password-msg').length) {
				$('.password-msg').html('Passwords do not match.');
			} else {
				$('.errors').find('ul').append('<li class="password-msg">Passwords do not match.</li>');
			}
		} else {
			$this.prepend('<div class="errors"><ul><li class="password-msg">Passwords do not match.</li></ul></div>');
		}
	}
});

  $("nav.mobile select").change(function(){ window.location = jQuery(this).val(); });
  $('#product .thumbs a').click(function(){
	
	$('#zoom-image').attr('href', $(this).attr('href'));
	return false;
  });

  $('#product .add-to-cart').click(function(e){
	$('#add-item-to-cart').click();
  });

  $('input[type="submit"], input.btn, button').click(function(){ // remove ugly outline on input button click
	$(this).blur();
  })

  $("li.dropdown").hover(function(){
	$(this).children('.dropdown').show();
	$(this).children('.dropdown').stop();
	$(this).children('.dropdown').animate({
	  opacity: 1.0
	}, 200);
  }, function(){
	$(this).children('.dropdown').stop();
	$(this).children('.dropdown').animate({
	  opacity: 0.0
	}, 400, function(){
	  $(this).hide();
	});
  });

  $('a[href^="#"]').bind('click.smoothscroll',function (e) {
	e.preventDefault();

	var target = this.hash,
		$target = $(target);

	$('html, body').stop().animate({
		'scrollTop': $target.offset().top
	}, 500, 'swing', function () {
		window.location.hash = target;
	});
  });

  var tabs = $('ul.tabs > li > a');
  tabs.each(function(i) {
	jQuery(this).unbind('click.smoothscroll')
	.click(function(e) {
		 var contentLocation = $(this).attr('href');
		 if(contentLocation.charAt(0)=="#") {
		tabs.removeClass('active');
		$(this).addClass('active');
		$(contentLocation).show().addClass('active').siblings().hide().removeClass('active');
		 }
	  return false;
	});
  });

  $('.nav-toggle').bind('click', function(e) {
		if(e.preventDefault) {
		  e.preventDefault();
		}
		var $this = $(this);
		var $nav = $this.parent().find('ul');
		var $header = $('#header');

		var navHeight = $nav.height() + 30;

		if(!$nav.hasClass('show')) {
		  $header.addClass('activated');
		  $nav.addClass('show');
		  /*$header.css({
			'margin-top' : navHeight + 'px'
		  });*/
		} else {
		  $nav.removeClass('show');
		  $header.removeClass('activated');
		  /*$header.css({
			'margin-top' : '0'
		  });*/
		}

		$('body, html').animate(
		  {
			'scrollTop' : 0
		  },
		  300
		);
  });

}); // end document ready